import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../scss/insurance-dashboard.style.scss';
// Imported only for the .mi-hero class used by the new heading. Every other
// rule in this file is scoped under .manage-invoice-v2 and can't leak here.
import '../scss/components/manage-invoice.style.scss';

/* Render the title with the LAST word styled as a violet gradient brand
   accent — works for any locale. Single-word titles are fully styled. */
const renderHeroTitle = (title: string) => {
    const trimmed = (title || '').trim();
    if (!trimmed) return null;
    const idx = trimmed.lastIndexOf(' ');
    if (idx === -1) {
        return <span className="mi-hero__brand">{trimmed}</span>;
    }
    const prefix = trimmed.slice(0, idx);
    const last = trimmed.slice(idx + 1);
    return (
        <>
            {prefix}{' '}
            <span className="mi-hero__brand">{last}</span>
        </>
    );
};

const ShieldIcon = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
        <path d="M12 2 4 5v6c0 5 3.4 8.5 8 11 4.6-2.5 8-6 8-11V5l-8-3z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
        <path d="m9 12 2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const AlertIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
        <path d="M12 9v4M12 17h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const FolderIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
        <path d="M3 7a2 2 0 0 1 2-2h4l2 2.5h8a2 2 0 0 1 2 2V18a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round" />
    </svg>
);

const DocumentIconSrc = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
    >
        <path
            d="M8 13C7.44772 13 7 13.4477 7 14C7 14.5523 7.44772 15 8 15V14V13ZM16 15C16.5523 15 17 14.5523 17 14C17 13.4477 16.5523 13 16 13V14V15ZM8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11V10V9ZM16 11C16.5523 11 17 10.5523 17 10C17 9.44772 16.5523 9 16 9V10V11ZM8 5C7.44772 5 7 5.44772 7 6C7 6.55228 7.44772 7 8 7V6V5ZM16 7C16.5523 7 17 6.55228 17 6C17 5.44772 16.5523 5 16 5V6V7ZM8 17C7.44772 17 7 17.4477 7 18C7 18.5523 7.44772 19 8 19V18V17ZM12 19C12.5523 19 13 18.5523 13 18C13 17.4477 12.5523 17 12 17V18V19ZM5.07805 21.7748L4.61708 22.6622L5.07805 21.7748ZM4.22517 20.9219L3.33776 21.3829L4.22517 20.9219ZM19.7748 20.9219L20.6622 21.3829L19.7748 20.9219ZM18.9219 21.7748L19.3829 22.6622L18.9219 21.7748ZM18.9219 2.22517L19.3829 1.33776L18.9219 2.22517ZM19.7748 3.07805L20.6622 2.61708L19.7748 3.07805ZM5.07805 2.22517L4.61708 1.33776L5.07805 2.22517ZM4.22517 3.07805L3.33776 2.61708L4.22517 3.07805ZM8 14V15H16V14V13H8V14ZM8 10V11H16V10V9H8V10ZM8 6V7H16V6V5H8V6ZM8 18V19H12V18V17H8V18ZM7.22 2V3H16.78V2V1H7.22V2ZM20 5.22H19V18.78H20H21V5.22H20ZM16.78 22V21H7.22V22V23H16.78V22ZM4 18.78H5V5.22H4H3V18.78H4ZM7.22 22V21C6.63372 21 6.25517 20.9992 5.96722 20.9753C5.69125 20.9524 5.58924 20.9135 5.53903 20.8874L5.07805 21.7748L4.61708 22.6622C5.00034 22.8613 5.39981 22.935 5.8017 22.9684C6.19162 23.0008 6.66729 23 7.22 23V22ZM4 18.78H3C3 19.3327 2.9992 19.8084 3.03158 20.1983C3.06495 20.6002 3.13867 20.9997 3.33776 21.3829L4.22517 20.9219L5.11259 20.461C5.0865 20.4108 5.04763 20.3088 5.02472 20.0328C5.0008 19.7448 5 19.3663 5 18.78H4ZM5.07805 21.7748L5.53903 20.8874C5.35638 20.7925 5.20746 20.6436 5.11259 20.461L4.22517 20.9219L3.33776 21.3829C3.62239 21.9309 4.06915 22.3776 4.61708 22.6622L5.07805 21.7748ZM20 18.78H19C19 19.3663 18.9992 19.7448 18.9753 20.0328C18.9524 20.3088 18.9135 20.4108 18.8874 20.461L19.7748 20.9219L20.6622 21.3829C20.8613 20.9997 20.935 20.6002 20.9684 20.1983C21.0008 19.8084 21 19.3327 21 18.78H20ZM16.78 22V23C17.3327 23 17.8084 23.0008 18.1983 22.9684C18.6002 22.935 18.9997 22.8613 19.3829 22.6622L18.9219 21.7748L18.461 20.8874C18.4108 20.9135 18.3088 20.9524 18.0328 20.9753C17.7448 20.9992 17.3663 21 16.78 21V22ZM19.7748 20.9219L18.8874 20.461C18.7925 20.6436 18.6436 20.7925 18.461 20.8874L18.9219 21.7748L19.3829 22.6622C19.9309 22.3776 20.3776 21.9309 20.6622 21.3829L19.7748 20.9219ZM16.78 2V3C17.3663 3 17.7448 3.0008 18.0328 3.02472C18.3088 3.04763 18.4108 3.0865 18.461 3.11259L18.9219 2.22517L19.3829 1.33776C18.9997 1.13867 18.6002 1.06495 18.1983 1.03158C17.8084 0.999196 17.3327 1 16.78 1V2ZM20 5.22H21C21 4.66729 21.0008 4.19162 20.9684 3.8017C20.935 3.39982 20.8613 3.00034 20.6622 2.61708L19.7748 3.07805L18.8874 3.53903C18.9135 3.58924 18.9524 3.69125 18.9753 3.96722C18.9992 4.25517 19 4.63372 19 5.22H20ZM18.9219 2.22517L18.461 3.11259C18.6436 3.20746 18.7925 3.35638 18.8874 3.53903L19.7748 3.07805L20.6622 2.61708C20.3776 2.06915 19.9309 1.62239 19.3829 1.33776L18.9219 2.22517ZM7.22 2V1C6.66729 1 6.19162 0.999196 5.8017 1.03158C5.39981 1.06495 5.00034 1.13867 4.61708 1.33776L5.07805 2.22517L5.53903 3.11259C5.58924 3.0865 5.69125 3.04763 5.96722 3.02472C6.25517 3.0008 6.63372 3 7.22 3V2ZM4 5.22H5C5 4.63372 5.0008 4.25517 5.02472 3.96722C5.04763 3.69125 5.0865 3.58924 5.11259 3.53903L4.22517 3.07805L3.33776 2.61708C3.13867 3.00034 3.06495 3.39981 3.03158 3.8017C2.9992 4.19162 3 4.66729 3 5.22H4ZM5.07805 2.22517L4.61708 1.33776C4.06915 1.62239 3.62239 2.06915 3.33776 2.61708L4.22517 3.07805L5.11259 3.53903C5.20746 3.35638 5.35638 3.20746 5.53903 3.11259L5.07805 2.22517Z"
            fill="currentColor"
        />
    </svg>
)
    ;
const DownloadIconSrc = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
        >
            <path
                d="M8.41996 0.834961C8.41996 0.373803 8.04612 -3.91006e-05 7.58496 -3.9041e-05C7.1238 -3.89814e-05 6.74996 0.373803 6.74996 0.834961L7.58496 0.834961L8.41996 0.834961ZM6.74996 9.08496C6.74996 9.54612 7.1238 9.91996 7.58496 9.91996C8.04612 9.91996 8.41996 9.54612 8.41996 9.08496H7.58496H6.74996ZM11.1754 8.1754C11.5015 7.84931 11.5015 7.32061 11.1754 6.99453C10.8493 6.66844 10.3206 6.66844 9.99453 6.99453L10.585 7.58496L11.1754 8.1754ZM8.11529 10.0546L7.52486 9.4642V9.4642L8.11529 10.0546ZM7.05463 10.0546L7.64507 9.4642V9.4642L7.05463 10.0546ZM5.1754 6.99453C4.84931 6.66844 4.32061 6.66844 3.99453 6.99453C3.66844 7.32061 3.66844 7.84931 3.99453 8.1754L4.58496 7.58496L5.1754 6.99453ZM1.66996 10.585C1.66996 10.1238 1.29612 9.74996 0.834961 9.74996C0.373803 9.74996 -3.9041e-05 10.1238 -3.9041e-05 10.585H0.834961H1.66996ZM15.17 10.585C15.17 10.1238 14.7961 9.74996 14.335 9.74996C13.8738 9.74996 13.5 10.1238 13.5 10.585H14.335H15.17ZM13.1064 14.0897L12.7274 13.3457L12.7274 13.3457L13.1064 14.0897ZM14.0897 13.1064L14.8337 13.4855V13.4855L14.0897 13.1064ZM1.0802 13.1064L0.336206 13.4855L1.0802 13.1064ZM2.06348 14.0897L1.6844 14.8337H1.6844L2.06348 14.0897ZM7.58496 0.834961L6.74996 0.834961L6.74996 9.08496H7.58496H8.41996L8.41996 0.834961L7.58496 0.834961ZM10.585 7.58496L9.99453 6.99453L7.52486 9.4642L8.11529 10.0546L8.70573 10.6451L11.1754 8.1754L10.585 7.58496ZM7.05463 10.0546L7.64507 9.4642L5.1754 6.99453L4.58496 7.58496L3.99453 8.1754L6.4642 10.6451L7.05463 10.0546ZM8.11529 10.0546L7.52486 9.4642C7.55805 9.431 7.61187 9.431 7.64507 9.4642L7.05463 10.0546L6.4642 10.6451C7.08318 11.264 8.08674 11.264 8.70573 10.6451L8.11529 10.0546ZM0.834961 10.585H-3.9041e-05V10.735H0.834961H1.66996V10.585H0.834961ZM4.43496 14.335V15.17H10.735V14.335V13.5H4.43496V14.335ZM14.335 10.735H15.17V10.585H14.335H13.5V10.735H14.335ZM10.735 14.335V15.17C11.3512 15.17 11.8637 15.1706 12.2808 15.1365C12.7076 15.1017 13.1075 15.0263 13.4855 14.8337L13.1064 14.0897L12.7274 13.3457C12.624 13.3984 12.4683 13.4456 12.1448 13.4721C11.8115 13.4993 11.3788 13.5 10.735 13.5V14.335ZM14.335 10.735H13.5C13.5 11.3788 13.4993 11.8115 13.4721 12.1448C13.4456 12.4683 13.3984 12.624 13.3457 12.7274L14.0897 13.1064L14.8337 13.4855C15.0263 13.1075 15.1017 12.7076 15.1365 12.2808C15.1706 11.8637 15.17 11.3512 15.17 10.735H14.335ZM13.1064 14.0897L13.4855 14.8337C14.066 14.5379 14.5379 14.066 14.8337 13.4855L14.0897 13.1064L13.3457 12.7274C13.2101 12.9936 12.9936 13.2101 12.7274 13.3457L13.1064 14.0897ZM0.834961 10.735H-3.9041e-05C-3.9041e-05 11.3512 -0.000688434 11.8637 0.0333885 12.2808C0.0682618 12.7076 0.143615 13.1075 0.336206 13.4855L1.0802 13.1064L1.82419 12.7274C1.77154 12.624 1.72428 12.4683 1.69784 12.1448C1.67061 11.8115 1.66996 11.3788 1.66996 10.735H0.834961ZM4.43496 14.335V13.5C3.79112 13.5 3.35846 13.4993 3.02516 13.4721C2.70161 13.4456 2.54588 13.3984 2.44256 13.3457L2.06348 14.0897L1.6844 14.8337C2.06238 15.0263 2.46234 15.1017 2.88917 15.1365C3.30625 15.1706 3.81868 15.17 4.43496 15.17V14.335ZM1.0802 13.1064L0.336206 13.4855C0.631976 14.066 1.10392 14.5379 1.6844 14.8337L2.06348 14.0897L2.44256 13.3457C2.17631 13.2101 1.95985 12.9936 1.82419 12.7274L1.0802 13.1064Z"
                fill="currentColor"
            />
        </svg>
    )
};
const ExternalLinkIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={18}
        height={18}
        viewBox="0 0 18 18"
        fill="none"
    >
        <path
            d="M14.915 6C14.915 6.46116 15.2888 6.835 15.75 6.835C16.2112 6.835 16.585 6.46116 16.585 6H15.75H14.915ZM12 1.415C11.5388 1.415 11.165 1.78884 11.165 2.25C11.165 2.71116 11.5388 3.085 12 3.085V2.25V1.415ZM8.40957 8.40957C8.08348 8.73565 8.08348 9.26435 8.40957 9.59043C8.73565 9.91652 9.26435 9.91652 9.59043 9.59043L9 9L8.40957 8.40957ZM15.7091 2.45475L14.9651 2.83383L14.9651 2.83384L15.7091 2.45475ZM15.5452 2.29087L15.1662 3.03486L15.1662 3.03486L15.5452 2.29087ZM9 4.585C9.46116 4.585 9.835 4.21116 9.835 3.75C9.835 3.28884 9.46116 2.915 9 2.915V3.75V4.585ZM15.085 9C15.085 8.53884 14.7112 8.165 14.25 8.165C13.7888 8.165 13.415 8.53884 13.415 9H14.25H15.085ZM3.88803 15.423L4.26711 14.679V14.679L3.88803 15.423ZM2.57698 14.112L1.83299 14.4911L2.57698 14.112ZM12.612 15.423L12.2329 14.679V14.679L12.612 15.423ZM13.923 14.112L13.179 13.7329H13.179L13.923 14.112ZM2.57698 5.38803L1.83299 5.00895L1.83299 5.00895L2.57698 5.38803ZM3.88803 4.07698L3.50895 3.33299L3.50895 3.33299L3.88803 4.07698ZM15.75 6H16.585V2.85H15.75H14.915V6H15.75ZM15.15 2.25V1.415H12V2.25V3.085H15.15V2.25ZM15.6402 2.35983L15.0497 1.7694L8.40957 8.40957L9 9L9.59043 9.59043L16.2306 2.95027L15.6402 2.35983ZM15.75 2.85H16.585C16.585 2.75877 16.5856 2.64013 16.5771 2.53571C16.5678 2.42154 16.5435 2.25311 16.4531 2.07567L15.7091 2.45475L14.9651 2.83384C14.9409 2.7862 14.9273 2.7434 14.92 2.71222C14.9133 2.68369 14.9123 2.66708 14.9127 2.6717C14.9131 2.67664 14.9139 2.69129 14.9145 2.72404C14.915 2.75677 14.915 2.79559 14.915 2.85H15.75ZM15.15 2.25V3.085C15.2044 3.085 15.2432 3.08502 15.276 3.08554C15.3087 3.08605 15.3234 3.08693 15.3283 3.08734C15.3329 3.08771 15.3163 3.08673 15.2878 3.08001C15.2566 3.07267 15.2138 3.05913 15.1662 3.03486L15.5452 2.29087L15.9243 1.54688C15.7469 1.45647 15.5785 1.43221 15.4643 1.42288C15.3599 1.41435 15.2412 1.415 15.15 1.415V2.25ZM15.7091 2.45475L16.4531 2.07568C16.3951 1.96184 16.3198 1.85863 16.2306 1.7694L15.6402 2.35983L15.0497 2.95027C15.0158 2.91635 14.9872 2.87711 14.9651 2.83383L15.7091 2.45475ZM15.6402 2.35983L16.2306 1.7694C16.1414 1.68017 16.0382 1.60488 15.9243 1.54688L15.5452 2.29087L15.1662 3.03486C15.1229 3.01281 15.0836 2.98418 15.0497 2.95027L15.6402 2.35983ZM9.45 15.75V14.915H7.05V15.75V16.585H9.45V15.75ZM2.25 10.95H3.085V8.55H2.25H1.415V10.95H2.25ZM7.05 3.75V4.585H9V3.75V2.915H7.05V3.75ZM14.25 9H13.415V10.95H14.25H15.085V9H14.25ZM7.05 15.75V14.915C6.19614 14.915 5.60597 14.9144 5.1476 14.8769C4.69898 14.8402 4.45065 14.7725 4.26711 14.679L3.88803 15.423L3.50895 16.167C3.96714 16.4005 4.45972 16.4963 5.01161 16.5414C5.55376 16.5856 6.2237 16.585 7.05 16.585V15.75ZM2.25 10.95H1.415C1.415 11.7763 1.41435 12.4462 1.45865 12.9884C1.50374 13.5403 1.59953 14.0329 1.83299 14.4911L2.57698 14.112L3.32097 13.7329C3.22745 13.5494 3.15975 13.301 3.1231 12.8524C3.08565 12.394 3.085 11.8039 3.085 10.95H2.25ZM3.88803 15.423L4.26711 14.679C3.85974 14.4715 3.52854 14.1403 3.32097 13.7329L2.57698 14.112L1.83299 14.4911C2.20066 15.2127 2.78734 15.7993 3.50895 16.167L3.88803 15.423ZM9.45 15.75V16.585C10.2763 16.585 10.9462 16.5856 11.4884 16.5414C12.0403 16.4963 12.5329 16.4005 12.9911 16.167L12.612 15.423L12.2329 14.679C12.0494 14.7725 11.801 14.8402 11.3524 14.8769C10.894 14.9144 10.3039 14.915 9.45 14.915V15.75ZM14.25 10.95H13.415C13.415 11.8039 13.4144 12.394 13.3769 12.8524C13.3402 13.301 13.2725 13.5494 13.179 13.7329L13.923 14.112L14.667 14.4911C14.9005 14.0329 14.9963 13.5403 15.0414 12.9884C15.0856 12.4462 15.085 11.7763 15.085 10.95H14.25ZM12.612 15.423L12.9911 16.167C13.7127 15.7993 14.2993 15.2127 14.667 14.4911L13.923 14.112L13.179 13.7329C12.9715 14.1403 12.6403 14.4715 12.2329 14.679L12.612 15.423ZM2.25 8.55H3.085C3.085 7.69614 3.08565 7.10597 3.1231 6.6476C3.15975 6.19898 3.22745 5.95065 3.32097 5.76711L2.57698 5.38803L1.83299 5.00895C1.59953 5.46714 1.50374 5.95972 1.45865 6.51161C1.41435 7.05376 1.415 7.7237 1.415 8.55H2.25ZM7.05 3.75V2.915C6.2237 2.915 5.55376 2.91435 5.01161 2.95865C4.45972 3.00374 3.96714 3.09953 3.50895 3.33299L3.88803 4.07698L4.26711 4.82097C4.45065 4.72745 4.69898 4.65975 5.1476 4.6231C5.60597 4.58565 6.19614 4.585 7.05 4.585V3.75ZM2.57698 5.38803L3.32097 5.76711C3.52854 5.35974 3.85974 5.02854 4.26711 4.82097L3.88803 4.07698L3.50895 3.33299C2.78734 3.70066 2.20066 4.28735 1.83299 5.00895L2.57698 5.38803Z"
            fill="white"
        />
    </svg>


)

export const InsuranceDashboard: React.FC = () => {
    const { t } = useTranslation();

    // Brief skeleton loading state for a smoother first-paint experience
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => setLoading(false), 850);
        return () => clearTimeout(timer);
    }, []);

    const handleReportIncident = () => {
        window.open('https://www.trygghansa.se/foretag/skadeanmalan', '_blank');
    };

    const handleDownloadLetter = () => {
        window.open('https://invozioprod.blob.core.windows.net/invoice-files/Försäkringsbrev_Invozio.pdf', '_blank');
    };

    if (loading) {
        return (
            <div className="insurance-premium">
                {/* <header className="ins-hero">
                    <span className="ins-hero__badge">
                        <ShieldIcon />
                        {t('PI_HERO_BADGE')}
                    </span>
                    <h1 className="ins-hero__title">{t('INSURANCE_DASHBOARD_MAIN_HEADING')}</h1>
                    <p className="ins-hero__subtitle">{t('INSURANCE_BASIC_PROTECTION')}</p>
                </header> */}

                <div className="ins-grid" aria-hidden="true">
                    <section className="ins-card ins-card--skeleton">
                        <div className="ins-skel ins-skel--icon" />
                        <div className="ins-skel ins-skel--title" />
                        <div className="ins-skel ins-skel--line" />
                        <div className="ins-skel ins-skel--line ins-skel--short" />
                        <div className="ins-skel ins-skel--panel" />
                        <div className="ins-skel ins-skel--btn" />
                    </section>
                    <section className="ins-card ins-card--skeleton">
                        <div className="ins-skel ins-skel--icon" />
                        <div className="ins-skel ins-skel--title" />
                        <div className="ins-skel ins-skel--doc" />
                        <div className="ins-skel ins-skel--line ins-skel--short" />
                    </section>
                </div>
            </div>
        );
    }

    return (
        <div className="insurance-premium">
            {/* Hero */}
            {/* Hero header — same soft violet card used by My Customers,
                Drafts, My Freelancers, Deductions, Statements and Earnings.
                ShieldIcon retained inside the badge as a thematic touch
                for the insurance context. */}
            <header className="mi-hero">
                <span className="mi-hero__badge">
                    <ShieldIcon />
                    {t('PI_HERO_BADGE')}
                </span>
                <h1 className="mi-hero__title">
                    {renderHeroTitle(t('INSURANCE_DASHBOARD_MAIN_HEADING'))}
                </h1>
                <p className="mi-hero__subtitle">{t('INSURANCE_BASIC_PROTECTION')}</p>
            </header>

            <div className="ins-grid">
                {/* Accident Report Card */}
                <section className="ins-card ins-card--claim">
                    <div className="ins-card__header">
                        <span className="ins-card__icon ins-card__icon--alert">
                            <AlertIcon />
                        </span>
                        <h2 className="ins-card__title">{t('HAVE_YOU_BEEN_IN_ACCIDENT_OR_CAUSED_DAMAGE')}</h2>
                    </div>
                    <div className="ins-card__body">
                        <p className="ins-card__desc">
                            {t('REPORT_INCIDENT_INSTRUCTIONS_FULL')}
                        </p>

                        {/* Key Information Section */}
                        <div className="ins-keyinfo">
                            <p className="ins-keyinfo__title">{t('KEY_INFORMATION')}</p>
                            <div className="ins-keyinfo__grid">
                                <div className="ins-keyinfo__item">
                                    <p className="ins-keyinfo__label">{t('CONTRACT_NUMBER')}</p>
                                    <p className="ins-keyinfo__value">25-2738090-08</p>
                                </div>
                                <div className="ins-keyinfo__item">
                                    <p className="ins-keyinfo__label">{t('COMPANY_NAME')}</p>
                                    <p className="ins-keyinfo__value">Invozio LV SIA</p>
                                </div>
                                <div className="ins-keyinfo__item">
                                    <p className="ins-keyinfo__label">{t('ORGANIZATION_NUMBER')}</p>
                                    <p className="ins-keyinfo__value">502085-4062</p>
                                </div>
                            </div>
                        </div>

                        {/* Action Button */}
                        <div className="ins-action">
                            <button className="ins-btn ins-btn--primary" onClick={handleReportIncident}>
                                <span>{t('REPORT_INCIDENT_TRYGG_HANSA')}</span>
                                <ExternalLinkIcon />
                            </button>
                            <p className="ins-action__note">{t('OPENS_EXTERNAL_CLAIM_SUBMISSION')}</p>
                        </div>
                    </div>
                </section>
            {/* Insurance Details Card */}
            {/* <div className="insurance-details-card-insurance">
                <div className="card-header-insurance">
                    <h2 className="card-title-insurance">{t('WHAT_INSURANCES_INCLUDED')}</h2>
                </div>
                <div className="card-content-insurance">
                    <p className="card-description-large-insurance">
                        {t('INVOZIO_ENSURES_SAFETY_NET')}
                    </p>
                </div>

                <div className="insurance-section-insurance">
                    <div className="insurance-section-container-insurance">
                        <div
                            className="insurance-section-header-insurance"
                            onClick={() => setIsLiabilityExpanded(!isLiabilityExpanded)}
                        >
                            <p className="section-title-insurance">{t('LIABILITY_INSURANCE')}</p>
                            <div className="chevron-icon-insurance">
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                                    <path
                                        d={isLiabilityExpanded ? "M3 7.5L6 4.5L9 7.5" : "M3 4.5L6 7.5L9 4.5"}
                                        stroke="currentColor"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </div>
                        </div>

                        {isLiabilityExpanded && (
                            <>
                                <div className="insurance-description-insurance">
                                    <p>{t('LIABILITY_INSURANCE_DESCRIPTION')}</p>
                                </div>

                                <div className="insurance-stats-insurance">
                                    <div className="stat-card-insurance">
                                        <p className="stat-label-insurance">{t('COMPENSATION_LIMIT')}</p>
                                        <p className="stat-value-insurance">10,000,000 SEK</p>
                                    </div>
                                    <div className="stat-card-insurance">
                                        <p className="stat-label-insurance">{t('COVERAGE')}</p>
                                        <p className="stat-value-insurance">{t('WORLDWIDE')}</p>
                                    </div>
                                    <div className="stat-card-insurance">
                                        <p className="stat-label-insurance">{t('EXCLUSIONS')}</p>
                                        <p className="stat-value-insurance">USA, Canada</p>
                                    </div>
                                </div>

                                <div className="coverage-areas-header-insurance">
                                    <p className="section-title-insurance">{t('COVERAGE_AREAS')}</p>
                                </div>

                                <div className="coverage-areas-grid-insurance">
                                    <CoverageAreaCard
                                        icon={DamageIconSrc}
                                        title={t('DAMAGE_TO_CLIENT_PROPERTY')}
                                        description={t('PROTECTION_PROPERTY_DAMAGE')}
                                    />
                                    <CoverageAreaCard
                                        icon={LossIconSrc}
                                        title={t('ECONOMIC_LOSSES_FROM_MISTAKES')}
                                        description={t('COVERAGE_FINANCIAL_LOSSES')}
                                    />
                                    <CoverageAreaCard
                                        icon={GeographicalIconSrc}
                                        title={t('WORLDWIDE_COVERAGE')}
                                        description={t('VALID_GLOBALLY_EXCLUDING')}
                                    />
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div> */}

                {/* Documents Card */}
                <section className="ins-card ins-card--docs">
                    <div className="ins-card__header">
                        <span className="ins-card__icon">
                            <FolderIcon />
                        </span>
                        <h2 className="ins-card__title">{t('DOCUMENTS')}</h2>
                    </div>
                    <div className="ins-card__body">
                        <div className="ins-doc">
                            <div className="ins-doc__info">
                                <div className="ins-doc__icon">
                                    <DocumentIconSrc />
                                </div>
                                <div className="ins-doc__details">
                                    <p className="ins-doc__title">{t('INSURANCE_LETTER')}</p>
                                    <div className="ins-doc__meta">
                                        {/* <span className="ins-doc__meta-item">
                                            <span className="ins-doc__dot"></span>
                                            <span>{t('PDF_DOCUMENT')}</span>
                                        </span> */}
                                        {/* <span className="meta-item-insurance">
                                        <span className="meta-dot-insurance"></span>
                                        <span>{t('LAST_UPDATED_JAN_2026')}</span>
                                    </span> */}
                                        <span className="ins-doc__meta-item">
                                            <span className="ins-doc__dot"></span>
                                            <span>{t('SWEDISH')}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <button className="ins-btn ins-btn--primary" onClick={handleDownloadLetter}>
                                <span>{t('DOWNLOAD_INSURANCE_LETTER')}</span>
                                <DownloadIconSrc />
                            </button>
                        </div>
                        <div className="ins-doc__note">
                            <p className='text-start'>{t('INSURANCE_DOCUMENT_DETAILS')}</p>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};
